<template>
  <div :class="['routines-drawer-wrapper', { 'routines-drawer-wrapper--border' : show }]">
    <div
      :id="id"
      :aria-hidden="show ? 'false' : 'true'"
      :class="['routines-drawer', { 'routines-drawer--show' : show }]"
    >
      <slot />
    </div>
  </div>
</template>

<script>
  import { eventBus } from '@Foundation/eventbus/eventbus';
  export default {
    name: 'RoutinesDrawer',
    props: {
      id: { type: String, required: true }
    },
    data() {
      return {
        show: false
      };
    },
    mounted() {
      eventBus.$on('routines-update', (id) => {
        this.show = this.id === id;
      });
    },
    methods: {
      toggle() {
        eventBus.$emit('routines-update', this.id);
      }
    }
  };
</script>
